const Match = () => import('@/components/Widget/Views/Match')
const WidgetLayout = () => import('@/components/Widget/Layout/WidgetLayout.vue')

export default {
  path: 'widget',
  component: WidgetLayout,
  redirect: {
    name: 'Sports',
  },
  children: [
    {
      path: 'page/:page/club/:clubId/:year/:week/match/:matchId',
      name: 'WidgetMatch',
      component: Match,
      props: true,
    },
  ],
}
